import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY.\n" +
      "Add them to .env (see .env.example) and restart the dev server — Vite only " +
      "reads env files at startup."
  );
}

// Everything in this file ships to the browser. Only the anon key belongs here;
// it is public by design and confined by RLS (see `npm run audit`). A service
// role key would hand every visitor unrestricted access to the database.
try {
  const claims = JSON.parse(atob(anonKey.split(".")[1]));
  if (claims.role && claims.role !== "anon") {
    throw new Error(
      `VITE_SUPABASE_ANON_KEY carries role "${claims.role}". Only the anon key may ` +
        "be used in frontend code. Replace it and rotate the exposed key immediately."
    );
  }
} catch (err) {
  if (err instanceof Error && err.message.startsWith("VITE_SUPABASE_ANON_KEY")) throw err;
  // Not a decodable JWT; let Supabase reject it on first use.
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
